export const apiConstants = {
  csrf: 'csrf-cookie',
  login: 'login',
  logout: 'logout',
  getUserDetails: 'getUser',
};
